import ForgottenPassForm from './ForgottenPassForm.vue';

export default ForgottenPassForm;
